import { Component, Vue } from 'vue-property-decorator'
import { namespace, State } from 'vuex-class'

const realtime = namespace('realtime')

@Component
export default class PresenceMixin extends Vue {
  private intervalId
  @State((state): number => state.constants.presenceCallIntervalInSeconds) private intervalInSeconds
  @realtime.Action private absent
  @realtime.Action private present

  private listener(): void {
    if (document.visibilityState === 'visible') {
      this.present()
      this.intervalId = setTimeout((): void => this.present(), this.intervalInSeconds)
    } else {
      clearInterval(this.intervalId)
      this.absent()
    }
  }

  private mounted(): void {
    document.addEventListener('visibilitychange', this.listener)
    this.listener()
  }

  private beforeDestroy(): void {
    document.removeEventListener('visibilitychange', this.listener)
  }
}
